<template>
  <div>
    <v-container>
      <h1>Quote Errors</h1>

      <v-card class="mb-4" :loading="quotesLoading">
        <v-card-title>
          Active Errors
        </v-card-title>
        <v-row class="pl-5">
              <RadioButtonGroup
                                class="dfc"
                                :options="[
                                    {value: false, text: 'Exclude Indication Errors'},
                                    {value: true, text: 'Include Indication Errors'}
                                ]"
                                :value="includeIndicationErrors"
                                :small="true"
                                :short="true"
                                @change="changeIndicationErrorMode($event)"
                            >
                            </RadioButtonGroup>
              <FormButton class="ml-5" label="Refresh" size="large" @click="getQuoteData" :disabled="quotesLoading"></FormButton>
        </v-row>
        <v-row class="pl-5">
        <v-col cols="3">
          <v-card class="mb-4">
            <v-card-text class="text-center">
              <h2 class="mb-2">Non Indication Errors:</h2>
              <h1 class="mb-0">
                {{ quoteErrorSummary.totalNonIndicationErrors }}
              </h1>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card class="mb-4">
            <v-card-text class="text-center">
              <h2 class="mb-2">Indication Errors:</h2>
              <h1 class="mb-0">
                {{ quoteErrorSummary.totalIndicationErrors }}
              </h1>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card class="mb-4">
            <v-card-text class="text-center">
              <h2 class="mb-2">Total Quote Errors:</h2>
              <h1 class="mb-0">
                {{ quoteErrorSummary.totalErrors }}
              </h1>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
        <v-card-text>
          <ResultsTable :tableHeaders="quoteTableHeaders" :results="quoteResults" :loading="quotesLoading">

            <template v-slot:UpdatedAt="{ item }">
              <span>
                {{ formatDateTimeForDisplay(item.UpdatedAt) }}
              </span>
            </template>

            <template v-slot:SubmissionId="{ item }">
              <span>
                {{ item.SubmissionId }}
              </span>
            </template>

            <template v-slot:SalesChannel="{ item }">
              <span>
                {{ item.SalesChannel }}
              </span>
            </template>

            <template v-slot:QuoteId="{ item }">
              <span>
                {{ item.QuoteId }}
              </span>
            </template>


            <template v-slot:ErrorText="{ item }">
              <span>
                {{ item.ErrorText }}
              </span>
            </template>


            <template v-slot:DebugText="{ item }">
              <span>
                {{ item.DebugText }}
              </span>
            </template>

            <template v-slot:Actions="{ item }">
              <div class="d-flex align-center">
                <ViewAccount :account="item.Account" target="_blank" />
                <v-btn v-if="requoting === false && item?.SubmissionId?.length > 0" @click="requote(item)" x-small class="ml-2">Requote</v-btn>
              </div>
            </template>

          </ResultsTable>
        </v-card-text>
      </v-card>

    </v-container>
  </div>
</template>

<script>
import { QuotesService } from '@/api/QuotesService';
import FormButton from '@/components/form/FormButton.vue';
import RadioButtonGroup from '@/components/form/RadioButtonGroup.vue';
import ViewAccount from '@/components/shared/ViewAccount.vue';
import ResultsTable from '@/components/shared/ResultsTable.vue';
import { makeFilterableText, formatDateTimeForDisplay, nonDefaultDate } from '@/scripts/helper';
import Environment from '@/scripts/environment';
import AxoisInstances from '@/plugins/axios';
import { GateService } from "@/api/GateService";


export default {
  name: 'QuoteErrors',
  components: {
    ResultsTable,
    FormButton,
    RadioButtonGroup,
    ViewAccount
  },
  data () {
    return {
      quotesLoading: false,
      includeIndicationErrors: false,
      requoting: false,
      quoteResults: [],
      quoteErrorSummary: { totalNonIndicationErrors: 0, totalIndicationErrors: 0, totalErrors: 0 },
      quoteTableHeaders: [
        { text: "UpdatedAt", value: "UpdatedAt", sortable: true, filterable: false },
        { text: "SubmissionId", value: "SubmissionId", sortable: true, filterable: true },
        { text: "Channel", value: "SalesChannel", sortable: true, filterable: true },
        { text: "QuoteId", value: "QuoteId", sortable: true, filterable: false },
        { text: "Error Text", value: "ErrorText", sortable: true, filterable: true },
        { text: "Debug Text", value: "DebugText", sortable: true, filterable: true },
        { text: "Actions", value: "Actions", sortable: false, filterable: false }
      ],
      quotesPending: true
    };
  },
  methods: {
    makeFilterableText,
    formatDateTimeForDisplay,
    nonDefaultDate,
    initialize () {
      // mock when in local host mode
      if (Environment.USEMOCK === true) {
        var MockAdapter = require("axios-mock-adapter");


        var mock = new MockAdapter(AxoisInstances.bff);
        mock.onGet("/api/Quotes/Errors")
          .reply(200, [
            {
              "Number": null,
              "SubmissionId": "SUB220002477",
              "SalesChannel": "Munich",
              "UpdatedAt": "2023-05-08T17:53:58+00:00",
              "Status": "Error",
              "DeclineType": null,
              "ErrorText": "Failed to get quote from MunichRECompactApiDataService",
              "DebugText": "Patch operation failed. Unable to determine the executed request hash",
              "Premium": null,
              "Fees": null,
              "Taxes": null,
              "PriceStatus": null,
              "PriceExpiration": null,
              "Expiration": null,
              "Total": null,
              "EffectiveDate": null,
              "ExpirationDate": null,
              "CovA": null,
              "CovB": null,
              "CovC": null,
              "CovD": null,
              "LossAssessmentLimit": null,
              "Liability": null,
              "MedPay": null,
              "PersonalInjury": null,
              "ReplacementCostDwelling": null,
              "ReplacementCostStructures": null,
              "ReplacementCostContents": null,
              "InflationGuard": null,
              "BuildingOrdinanceOrLaw": null,
              "WindDrivenRain": null,
              "Theft": null,
              "Mold": null,
              "DomesticAnimalLiability": null,
              "WaterBackup": null,
              "WaterDamageSublimit": null,
              "TotalPeril": null,
              "WindHailPeril": null,
              "EarthquakePeril": null,
              "FloodPeril": null,
              "WaterDamagePeril": null,
              "Footnote": null,
              "id": "SUB220002477:Munich"
            },
            {
              "Number": null,
              "SubmissionId": "SUB220002006",
              "SalesChannel": "Munich",
              "UpdatedAt": "2023-04-26T20:43:05+00:00",
              "Status": "Error",
              "DeclineType": null,
              "ErrorText": "Failed to get quote from WebApplicationPatch",
              "DebugText": "Response status code does not indicate success: 400 (Bad Request).",
              "Premium": null,
              "Fees": null,
              "Taxes": null,
              "PriceStatus": null,
              "PriceExpiration": null,
              "Expiration": null,
              "Total": null,
              "EffectiveDate": null,
              "ExpirationDate": null,
              "CovA": null,
              "CovB": null,
              "CovC": null,
              "CovD": null,
              "LossAssessmentLimit": null,
              "Liability": null,
              "MedPay": null,
              "PersonalInjury": null,
              "ReplacementCostDwelling": null,
              "ReplacementCostStructures": null,
              "ReplacementCostContents": null,
              "InflationGuard": null,
              "BuildingOrdinanceOrLaw": null,
              "WindDrivenRain": null,
              "Theft": null,
              "Mold": null,
              "DomesticAnimalLiability": null,
              "WaterBackup": null,
              "WaterDamageSublimit": null,
              "TotalPeril": null,
              "WindHailPeril": null,
              "EarthquakePeril": null,
              "FloodPeril": null,
              "WaterDamagePeril": null,
              "Footnote": null,
              "id": "SUB220002006:Munich"
            },
            {
              "Number": null,
              "SubmissionId": "SUB220002009",
              "SalesChannel": "Munich",
              "UpdatedAt": "2023-04-25T12:55:40+00:00",
              "Status": "Error",
              "DeclineType": null,
              "ErrorText": "Failed to get quote from WebApplicationPatch",
              "DebugText": "Response status code does not indicate success: 400 (Bad Request).",
              "Premium": null,
              "Fees": null,
              "Taxes": null,
              "PriceStatus": null,
              "PriceExpiration": null,
              "Expiration": null,
              "Total": null,
              "EffectiveDate": null,
              "ExpirationDate": null,
              "CovA": null,
              "CovB": null,
              "CovC": null,
              "CovD": null,
              "LossAssessmentLimit": null,
              "Liability": null,
              "MedPay": null,
              "PersonalInjury": null,
              "ReplacementCostDwelling": null,
              "ReplacementCostStructures": null,
              "ReplacementCostContents": null,
              "InflationGuard": null,
              "BuildingOrdinanceOrLaw": null,
              "WindDrivenRain": null,
              "Theft": null,
              "Mold": null,
              "DomesticAnimalLiability": null,
              "WaterBackup": null,
              "WaterDamageSublimit": null,
              "TotalPeril": null,
              "WindHailPeril": null,
              "EarthquakePeril": null,
              "FloodPeril": null,
              "WaterDamagePeril": null,
              "Footnote": null,
              "id": "SUB220002009:Munich"
            }
          ]);
      }

      this.getQuoteData();
    },
    changeIndicationErrorMode () {
      if (this.quotesLoading) return;
      this.includeIndicationErrors = !this.includeIndicationErrors;
      this.getQuoteData();
    },
    async requote (quoteError) {
      this.requoting = true;
      quoteError.id = quoteError.SubmissionId;
      // fire the requote request
      await GateService.requoteForSalesChannel({
        body: quoteError,
        salesChannel: quoteError.SalesChannel
      })
        .then(() => {
          // pop the requeued item from the Quote Error list
          let indexToRemove = this.quoteResults.findIndex(x => x.SubmissionId == quoteError.SubmissionId);
          this.quoteResults.splice(indexToRemove, 1);
          this.quoteErrorSummary.totalNonIndicationErrors--;
          this.quoteErrorSummary.totalErrors--;
          console.log(`Requote for ${quoteError.SalesChannel} / ${quoteError.SubmissionId} queued`);
        })
        .catch((error) => {
          // super helpful
          console.log(['Requote failed', error]);
          this.$store.dispatch('toastError', { Message: `Requote failed for ${quoteError.id}!` });
        })
        .finally(() => {
          this.requoting = false;
        });
    },
    getQuoteData () {
      this.quoteResults = [];
      this.quotesLoading = true;

      QuotesService.errors({ limit: 100, includeIndication: this.includeIndicationErrors })
        .then((response) => {
          this.quoteErrorSummary.totalErrors = response.TotalErrors ?? 0;
          this.quoteErrorSummary.totalNonIndicationErrors = response.TotalNonIndicationErrors ?? 0;
          this.quoteErrorSummary.totalIndicationErrors = response.TotalIndicationErrors ?? 0;
          response.QuoteErrors.forEach(item => {
            // pass though item.UpdatedAt = item.UpdatedAt;
            item.SubmissionId = this.makeFilterableText(item, 'SubmissionId');
            item.SalesChannel = this.makeFilterableText(item, 'SalesChannel');
            item.QuoteId = item.id;
            item.ErrorText = this.makeFilterableText(item, 'ErrorText');
            item.DebugText = this.makeFilterableText(item, 'DebugText');
            item.Account = { id: item.SubmissionId, AccountStatus: 'Incomplete' };
            this.quoteResults.push(item);
          });
        })
        .finally(() => {
          this.quotesLoading = false;
        });
    }
  },
  mounted () {
    this.initialize();
  }
};
</script>
